import * as React from "react";
const WhiteBreakpointStar = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={12}
        height={12}
        fill="none"
        {...props}
    >
        <path
            fill="#fff"
            d="M10.607 1.812 12 4.188 7.167 6 12 7.893l-1.393 2.295-4.013-3.222L7.372 12H4.669l.737-5.034-4.014 3.222L0 7.893 4.874 6 0 4.188l1.392-2.376 4.014 3.222L4.67 0h2.703l-.778 4.993 4.013-3.18Z"
        />
    </svg>
);
export default WhiteBreakpointStar;
